<script lang="ts" setup>
import { NConfigProvider } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'
import { theme } from '~~/theme'

const { $isMobile } = useNuxtApp()
const screen = useScreen()
const { scrolled, scrollY, scrollBottom } = useScrollState()

onMounted(() => {
  useAuth().refreshBadge()

  const mqlScreenXs = window.matchMedia(deviceSizeQuery.xs)
  const mqlScreenSm = window.matchMedia(deviceSizeQuery.sm)
  const mqlScreenMd = window.matchMedia(deviceSizeQuery.md)
  const mqlScreenLg = window.matchMedia(deviceSizeQuery.lg)
  const mqlScreenXl = window.matchMedia(deviceSizeQuery.xl)

  screen.value.xs = !!mqlScreenXs?.matches
  screen.value.sm = !!mqlScreenSm?.matches
  screen.value.md = !!mqlScreenMd?.matches
  screen.value.lg = !!mqlScreenLg?.matches
  screen.value.xl = !!mqlScreenXl?.matches

  window.addEventListener('resize', () => {
    screen.value.lg = !!mqlScreenLg?.matches
    screen.value.md = !!mqlScreenMd?.matches
    screen.value.sm = !!mqlScreenSm?.matches
    screen.value.xs = !!mqlScreenXs?.matches
  })
  const imgElements = document.querySelectorAll('img')
  imgElements.forEach(function (img) {
    img.addEventListener('error', function () {
      img.src = 'https://resource.mfuns.net/image/placeholder/img-404.png'
    })
  })

  scrollBottom.value =
    document.documentElement.scrollHeight - window.innerHeight
  window.addEventListener('scroll', (e) => {
    scrollY.value = window.scrollY
    scrolled.value = window.scrollY > 0
    // scrollBottom是距离页面底部的距离
    scrollBottom.value =
      document.documentElement.scrollHeight -
      window.innerHeight -
      window.scrollY
  })
})
screen.value.xs = $isMobile()
screen.value.lg = !$isMobile()

const deviceSizeQuery = {
  xs: '(max-width: 600px)',
  sm: '(min-width: 600px) and (max-width: 960px)',
  md: '(min-width: 960px) and (max-width: 1280px)',
  lg: '(min-width: 1280px) and (max-width: 1540px)',
  xl: '(min-width: 1540px)'
}
</script>

<template>
  <n-config-provider
    :locale="zhCN"
    :date-locale="dateZhCN"
    :theme-overrides="theme"
    inline-theme-disabled
    abstract
  >
    <n-dialog-provider to="body">
      <n-message-provider to="body">
        <n-loading-bar-provider to="body">
          <NuxtLayout>
            <NuxtPage />
          </NuxtLayout>
        </n-loading-bar-provider>
      </n-message-provider>
    </n-dialog-provider>
  </n-config-provider>
</template>
